import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./map-boundary-fetch-fallback";
import { AuthProvider } from "./auth";
import { AppRoutes } from "./routes";
import "./styles.css";
import "./certificate.css";
import "./profile-parity.css";
import "./reports-desktop-parity.css";
import "./report-age-names.css";
import "./user-management.css";
import "./lira-conversation.css";
import "./municipality-barangay-map.css";

createRoot(document.getElementById("root")!).render(<StrictMode><BrowserRouter><AuthProvider><AppRoutes /></AuthProvider></BrowserRouter></StrictMode>);
